import React, { useEffect, useState } from 'react';
import ProgressSpinner from '@smart-tv/components/progress-spinner';
import styles from './player-product-sheet-info.module.scss';

interface PlayerProductSheetSpinnerProps {
  error: unknown;
}

const PlayerProductSheetSpinner = ({ error }: PlayerProductSheetSpinnerProps) => {
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSpinner(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {showSpinner && (
        <div className={styles['player-product-sheet-info__spinner']}>
          {error ? 'Kunne ikke indlæse info om programmet' : <ProgressSpinner />}
        </div>
      )}
    </>
  );
};

export default PlayerProductSheetSpinner;
